import { FileItemsList } from 'new/elements/FileItemsList';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import RoutePrefixContext from '../../../../new/contexts/RoutePrefixContext';
import { FILE_LIST_MODE_TYPES, FILE_LIST_SORT_CRITERIA } from 'js/constants/paginationConstants';
import { QUARANTINE_FILES_PAGINATED } from 'js/constants/paginationEntitiesTypes';
import FilesListingView from '../files/FilesListingView';
import ErrorDataSettingsConfig from 'new/components/monitor/ErrorDataSettings/screenConfig';

import './QuarantineDataTab.scss';

class QuarantineFilesView extends Component {
  static contextType = RoutePrefixContext;

  constructor(props) {
    super(props);
    this.state = {
      selectedPath: '',
      filters: {
        page: 1,
        size: 100,
        orderby: FILE_LIST_SORT_CRITERIA.LAST_CREATED_DESC.value,
        status: '',
      },
    };
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.data.id !== prevProps.data.id ||
      this.props.resourceType !== prevProps.resourceType
    ) {
      this.loadData();
    }
  }

  componentWillUnmount() {
    const { data, resourceType } = this.props;

    let fetchResourceId = data ? data.id : null;

    this.props.clearPaginatedResource(QUARANTINE_FILES_PAGINATED, resourceType, fetchResourceId);
  }

  loadData = () => {
    const { data, resourceType, fetchResourceQuarantineFiles } = this.props;

    if (!data?.id) {
      return;
    }

    fetchResourceQuarantineFiles(data?.id, resourceType, this.state.filters, 'lastWritten');
  };

  loadMore = (page) => {
    const { data, resourceType, fetchResourceQuarantineFiles } = this.props;
    if (page) {
      fetchResourceQuarantineFiles(
        data?.id,
        resourceType,
        {
          ...this.state.filters,
          page,
          aggregate: true,
        },
        'lastWritten',
      );
    }
  };

  render() {
    const { isLoading, files } = this.props;
    const { filters } = this.state;
    const mode = FILE_LIST_MODE_TYPES.MODE_QUARANTINE_FILES;

    return (
      <section>
        <div className="error-export-description">
          Exported error files for this resource if you have configured Nexla to automatically
          export all error data to your preferred file system. Configure export settings in{' '}
          <Link to={ErrorDataSettingsConfig.path}>Error Data Export</Link>
        </div>

        <div className="error-export-filters">
          <FilesListingView
            mode={mode}
            fileStats={null}
            files={files}
            filters={filters}
            disablePagination={this.props.version === '2'}
            updateFilters={this._updateFilters}
          />
        </div>

        <FileItemsList
          parentScrollRef={this.props.parentScrollRef}
          height={this.props.height}
          disableVirtualization={!this.props.height && !this.props.parentScrollRef}
          loading={isLoading}
          loadMore={this.loadMore}
          items={files.data || []}
          resourceId={this.props?.data?.id}
          connectionCategory={this.props.data?.connectionCategory}
          useFiles
          hideStats
          totalCount={files?.meta?.totalCount}
          pageCount={files?.meta?.pageCount}
          currentPage={files?.meta?.currentPage}
          mode={FILE_LIST_MODE_TYPES.MODE_QUARANTINE_FILES}
          resourceType={this.props.resourceType}
        />
      </section>
    );
  }

  _updateFilters = (changedFilters) => {
    const { filters } = this.state;

    this.setState({ filters: { ...filters, ...changedFilters } }, () => this.loadData());
  };
}

export default QuarantineFilesView;
